import styled, { css } from 'styled-components';
import { SizesType, StatusButtonType } from '../ThemeProvider/types';

export const Label = styled.label`
  color: ${({ theme }) => theme.gray4D};
  padding-left: 10px;
  cursor: pointer;
  user-select: none;
`;

export const Container = styled.div<{ size: SizesType }>`
  transition: all 0.17s;
  font-family: 'Mulish', sans-serif;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  line-height: 20px;
  display: flex;
  align-items: center;
  ${({ theme, size }) => css`
    & > ${Label} {
      line-height: ${theme.checkbox.sizes[size].lineHeight}px;
      font-size: ${theme.checkbox.sizes[size].fontSize}px;
    }
  `}
`;

export const Span = styled.span<{
  size: SizesType;
}>`
  border: 2px solid;
  border-radius: 3px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  ${({ size, theme }) => css`
    border-color: ${theme.gray80};
    height: ${`${theme.checkbox.sizes[size].box}px`};
    width: ${`${theme.checkbox.sizes[size].box}px`};
  `}
`;

export const Input = styled.input<{ status: StatusButtonType; checked: boolean }>`
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;

  &:disabled ~ ${Label} {
    cursor: default;
    color: ${({ theme }) => theme.grayCC};
  }

  &:disabled ~ ${Span} > div {
    cursor: default;
  }

  ${({ checked, theme, status }) =>
    checked
      ? css`
          & ~ ${Span} {
            background-color: ${theme.status[status].color};
            border-color: ${theme.status[status].color};
          }
          &:disabled ~ ${Span} {
            border-color: ${theme.grayCC};
            background-color: ${theme.grayCC};
            cursor: default;
          }
          & ~ ${Span}:after {
            display: block;
          }
        `
      : css`
          & ~ ${Span} svg {
            opacity: 0;
          }
          &:disabled ~ ${Span} {
            background-color: ${theme.checkbox.colors.background};
            border-color: ${theme.grayCC};
            cursor: default;
          }
        `}
`;
